// Messages for operator/quotes/TemplateFormModal (auto-merged by lib/i18n.ts).
export const en = {
  'operator.template_form.mode.ship': 'Ocean',
  'operator.template_form.mode.air': 'Air',
  'operator.template_form.mode.truck': 'Truck',
  'operator.template_form.mode.train': 'Rail',
  'operator.template_form.title': 'New template',
  'operator.template_form.cancel': 'Cancel',
  'operator.template_form.create': 'Create template',
  'operator.template_form.section.template': 'Template',
  'operator.template_form.field.name': 'Name',
  'operator.template_form.name_placeholder': 'Ocean · SHA → Chicago',
  'operator.template_form.field.mode': 'Mode',
  'operator.template_form.mode_aria': 'Mode',
  'operator.template_form.mode_any': 'Any mode',
  'operator.template_form.field.default_currency': 'Default currency',
  'operator.template_form.default_currency_aria': 'Default currency',
  'operator.template_form.field.container_size': 'Container size',
  'operator.template_form.container_size_aria': 'Container size',
  'operator.template_form.container_size_placeholder': 'FCL / LCL',
  'operator.template_form.field.incoterm': 'Incoterm',
  'operator.template_form.incoterm_aria': 'Incoterm',
  'operator.template_form.incoterm_placeholder': 'Select an incoterm',
  'operator.template_form.field.cargo_details': 'Cargo details',
  'operator.template_form.cargo_details_aria': 'Cargo details',
  'operator.template_form.cargo_details_placeholder': 'Commodity, packing, dimensions…',
  'operator.template_form.field.remarks': 'Remarks',
  'operator.template_form.remarks_aria': 'Remarks',
  'operator.template_form.remarks_placeholder': 'Internal notes or conditions',
  'operator.template_form.section.charges': 'Charges',
}

export const zhTW = {
  'operator.template_form.mode.ship': '海運',
  'operator.template_form.mode.air': '空運',
  'operator.template_form.mode.truck': '卡車',
  'operator.template_form.mode.train': '鐵路',
  'operator.template_form.title': '新範本',
  'operator.template_form.cancel': '取消',
  'operator.template_form.create': '建立範本',
  'operator.template_form.section.template': '範本',
  'operator.template_form.field.name': '名稱',
  'operator.template_form.name_placeholder': '海運 · SHA → 芝加哥',
  'operator.template_form.field.mode': '運輸方式',
  'operator.template_form.mode_aria': '運輸方式',
  'operator.template_form.mode_any': '任何運輸方式',
  'operator.template_form.field.default_currency': '預設貨幣',
  'operator.template_form.default_currency_aria': '預設貨幣',
  'operator.template_form.field.container_size': '貨櫃類型',
  'operator.template_form.container_size_aria': '貨櫃類型',
  'operator.template_form.container_size_placeholder': 'FCL / LCL',
  'operator.template_form.field.incoterm': '貿易條件',
  'operator.template_form.incoterm_aria': '貿易條件',
  'operator.template_form.incoterm_placeholder': '選擇貿易條件',
  'operator.template_form.field.cargo_details': '貨物明細',
  'operator.template_form.cargo_details_aria': '貨物明細',
  'operator.template_form.cargo_details_placeholder': '品名、包裝、尺寸…',
  'operator.template_form.field.remarks': '備註',
  'operator.template_form.remarks_aria': '備註',
  'operator.template_form.remarks_placeholder': '內部備註或條件',
  'operator.template_form.section.charges': '費用項目',
}
